import { render, staticRenderFns } from "./NColSort.vue?vue&type=template&id=78f2cd33"
import script from "./NColSort.vue?vue&type=script&lang=js"
export * from "./NColSort.vue?vue&type=script&lang=js"
import style0 from "./NColSort.vue?vue&type=style&index=0&id=78f2cd33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports